export enum EPropCertificatesTypes {
    GET_CERTIFICATES_START = '[prop-certificates] get certificates start',
    GET_CERTIFICATES_SUCCESS = '[prop-certificates] get certificates success',
    GET_CERTIFICATES_FAIL = '[prop-certificates] get certificates fail',

    RENDER_CERTIFICATE_START = '[prop-certificates] render certificate start',
    RENDER_CERTIFICATE_SUCCESS = '[prop-certificates] render certificate success',
    RENDER_CERTIFICATE_FAIL = '[prop-certificates] render certificate fail',

    GET_THUMBNAILS_START = '[prop-certificates] get thumbnails start',
    GET_THUMBNAILS_SUCCESS = '[prop-certificates] get thumbnails success',
    GET_THUMBNAILS_FAIL = '[prop-certificates] get thumbnails fail',

    GET_SHARE_LINK_SUCCESS = '[prop-certificates] get share link success',
}
